import { useMemo } from "react";
import { useTerritoryQuery } from "../../../../queries";
import { ReferralRowProps } from ".";
import { useSelectOptionsFromSlug } from "../../../../hooks";
import { Icon, fas } from "../../../../component-library";

export function ReferralHbovRow({ case: _case, onClick }: Readonly<ReferralRowProps>) {
    const {
        listQuery: { data: territories },
    } = useTerritoryQuery();
    const { patientFirstName, patientLastName, overallStatus, number, territoryId } = _case.referral ?? {};
    const referralTypeOptions = useSelectOptionsFromSlug("referral_type");

    const referralType = useMemo(
        () => referralTypeOptions.find((r) => r.value === _case.referral?.potentialDonorType)?.label ?? "-",
        [_case.referral?.potentialDonorType, referralTypeOptions]
    );

    const territory = territories?.find((t) => t.id === territoryId);

    const hasAlert = useMemo(() => overallStatus === "Organ Case Pending OR Time", [overallStatus]);

    return (
        <tr className="referral-row clickable" onClick={onClick} tabIndex={0}>
            <td>{number}</td>
            <td className="text-nowrap fw-bold">
                {patientFirstName} {patientLastName}
            </td>
            <td className={hasAlert ? "fw-bold text-danger" : ""}>{overallStatus}</td>
            <td>{referralType}</td>
            <td>{territory?.label ?? territory?.name}</td>
            <td>
                {_case.hasFlaggedForms && (
                    <Icon
                        icon={fas.faFlag}
                        className="text-danger"
                        title="This referral has flagged forms"
                        aria-label="This referral has flagged forms"
                    />
                )}
            </td>
        </tr>
    );
}
